import { connect } from 'react-redux'
import { selectAuthUser } from '~/store/auth/selector'
import MasterLayout from './MasterLayout'

const mapStateToProps = (state) => ({
  isAuthenticated: !!selectAuthUser(state)
})

const mapDispatch = {}

export default connect(mapStateToProps, mapDispatch)(MasterLayout)
